'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashboardConfig = exports.DashboardConfig = function DashboardConfig($stateProvider) {
  'ngInject';

  $stateProvider.state('app.dashboard', {
    url: '^/dashboard',
    template: '<dashboard></dashboard>'
  });
};

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/dashboard/dashboard.config.js
 **/